import { useState } from "react";
import PropertyListingCard from "@/components/PropertyListingCard";
import { useProperties } from "@/hooks/useProperties";

const PropertiesForSale = () => {
  const [activeCategory, setActiveCategory] = useState("ready");
  const { data: properties, isLoading } = useProperties({ listing_type: "sale", category: activeCategory, is_featured: true, limit: 6 });
  const activeCategoryLabel = activeCategory === "offplan"
    ? "Offplan"
    : activeCategory === "under-construction"
      ? "Under Construction"
      : "Ready";

  return (
    <section id="properties-for-sale" className="bg-brand-canvas py-16 md:py-24">
      <div className="px-6 md:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="font-open-sans font-semibold text-xs tracking-[0.3em] uppercase text-logo-gold mb-6">Premium Properties</p>
          <h2 className="font-open-sans font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-logo-gold-gradient mb-8 leading-tight">Properties for Sale</h2>
          <div className="max-w-3xl mx-auto">
            <p className="font-open-sans text-lg leading-relaxed text-primary-foreground/75">
              Whether you're looking for immediate possession or strategic investment opportunities, our curated selection of premium properties offers exceptional value.
            </p>
          </div>
        </div>

        <div className="flex justify-center mb-12">
          <div className="grid w-full max-w-2xl grid-cols-1 rounded-lg border border-primary-foreground/15 bg-background/10 p-1 backdrop-blur-sm sm:grid-cols-3">
            <button onClick={() => setActiveCategory("offplan")} className={`px-4 py-3 font-open-sans font-semibold text-xs md:text-sm tracking-wider uppercase leading-tight transition-all duration-300 rounded-md whitespace-nowrap ${activeCategory === "offplan" ? "bg-logo-gold-gradient shadow-logo-gold border border-logo-gold text-[#3A2A0D]" : "text-primary-foreground/70 hover:text-primary-foreground"}`}>Offplan</button>
            <button onClick={() => setActiveCategory("under-construction")} className={`px-4 py-3 font-open-sans font-semibold text-xs md:text-sm tracking-wider uppercase leading-tight transition-all duration-300 rounded-md ${activeCategory === "under-construction" ? "bg-logo-gold-gradient shadow-logo-gold border border-logo-gold text-[#3A2A0D]" : "text-primary-foreground/70 hover:text-primary-foreground"}`}>Under Construction</button>
            <button onClick={() => setActiveCategory("ready")} className={`px-4 py-3 font-open-sans font-semibold text-xs md:text-sm tracking-wider uppercase leading-tight transition-all duration-300 rounded-md whitespace-nowrap ${activeCategory === "ready" ? "bg-logo-gold-gradient shadow-logo-gold border border-logo-gold text-[#3A2A0D]" : "text-primary-foreground/70 hover:text-primary-foreground"}`}>Ready</button>
          </div>
        </div>

        {isLoading ? (
          <p className="text-center text-primary-foreground/70 font-open-sans">Loading properties...</p>
        ) : properties && properties.length > 0 ? (
          <div className="grid gap-8 md:grid-cols-3 mb-16">
            {properties.map((property) => (
              <PropertyListingCard key={property.id} {...property} statusLabel={property.status_label} categoryLabel={property.category_label} />
            ))}
          </div>
        ) : (
          <p className="text-center text-primary-foreground/70 font-open-sans mb-16">No properties available yet.</p>
        )}

        <div className="text-center">
          <a href="/properties-for-sale" className="inline-block font-open-sans font-bold text-xs tracking-[0.25em] uppercase bg-logo-gold-gradient shadow-logo-gold border border-logo-gold text-[#3A2A0D] px-10 py-4 hover:opacity-95 transition-all duration-300">
            View All {activeCategoryLabel} Properties
          </a>
        </div>
      </div>
    </section>
  );
};

export default PropertiesForSale;
